<script>
export default {
  props: {
    chartType: {
      type: String,
      default: 'bar'
    },
    chartData: {
      type: Object,
      required: true
    },
    stacked: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      chartDataComputed: null,
      chartOptions: null
    };
  },
  mounted() {
    this.chartDataComputed = this.setChartData();
    this.chartOptions = this.setChartOptions();
  },
  methods: {
    setChartData() {
      const documentStyle = getComputedStyle(document.documentElement);

      // TODO: Loop over all datasets and set the backgroundColor
      // TODO: backgroundColor: documentStyle.getPropertyValue('--p-cyan-500'),
      // TODO: backgroundColor: documentStyle.getPropertyValue('--p-gray-500'),
      return {
        datasets: this.chartData
      };
    },
    setChartOptions() {
      const documentStyle = getComputedStyle(document.documentElement);
      const textColor = documentStyle.getPropertyValue('--p-text-color');
      const textColorSecondary = documentStyle.getPropertyValue('--p-text-muted-color');
      const surfaceBorder = documentStyle.getPropertyValue('--p-content-border-color');

      return {
        maintainAspectRatio: false,
        indexAxis: 'y',
        plugins: {
          legend: {
            labels: {
              color: textColor
            }
          }
        },
        scale: {
          ticks: {
            precision: 0, // No decimal places
          },
        },
        scales: {
          x: {
            stacked: this.stacked,
            ticks: {
              color: textColorSecondary
            },
            grid: {
              color: surfaceBorder
            }
          },
          y: {
            stacked: this.stacked,
            beginAtZero: true,
            ticks: {
              color: textColorSecondary
            },
            grid: {
              color: surfaceBorder
            }
          }
        }
      };
    }
  }
}
</script>

<template>

  <Chart :type="chartType" :data="chartDataComputed" :options="chartOptions" height="400" />

</template>

<style>
 /* See agenda.scss for styling. Styling is here because we want the Gin/Bootstrap variables. */
</style>
